import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useTaskType, TaskType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<TaskType>
      useData={useTaskType}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

